import React from 'react';
import { StyledHeader, StyledChunk } from './section-headline.style';

interface ISectionTitle {
    firstChunk: string;
    secondChunk?: string;
    color?: 'dark' | 'light';
    paddingBottom?: number;
    headerType?: string;
}

export const SectionHeadline = (props: ISectionTitle) => {
    const { firstChunk, secondChunk, color = 'dark', paddingBottom = '25', headerType } = props;
    return (
        <StyledHeader as={headerType} color={color} paddingBottom={paddingBottom + 'px'}>
            <StyledChunk>{firstChunk}</StyledChunk>
            <StyledChunk>{secondChunk}</StyledChunk>
        </StyledHeader>
    );
};
